import React, { FunctionComponent } from 'react';
import { IconColor, IconName, Icon } from 'app/common/components/controls';
import { IconButton } from 'app/common/components/controls/button/button';
import { forNamespace } from 'app/common/lib/util/i18n';
import { Noun, Verb } from '@trello/analytics';
import { track } from '../Analytics';

import styles from './OnboardingDialog.less';

const WaveImageUrl = require('resources/images/onboarding-banner/Wave.svg');
const TacoImageUrl = require('resources/images/onboarding-banner/Taco.svg');

const format = forNamespace(['aa onboarding', 'dialog']);
const analyticsSource = 'onboardingDialog';

interface DialogProps {
  title: React.ReactNode;
  helpLink?: string;
  closeDialog: () => void;
  onClickGoBack: () => void;
}

export const preloadOnboardingImages = () => {
  new Image().src = WaveImageUrl;
  new Image().src = TacoImageUrl;
};

export const OnboardingDialog: FunctionComponent<DialogProps> = ({
  title,
  helpLink,
  children,
  closeDialog,
  onClickGoBack,
}) => (
  <div className={styles.dialog}>
    <div className={styles.backButton}>
      <a role="link" onClick={() => onClickGoBack()}>
        <Icon name={IconName.Back} small quiet />
        {format('back')}
      </a>
    </div>
    <div className={styles.controls}>
      {helpLink && (
        <IconButton
          icon={IconName.Information}
          className={styles.icon}
          color={IconColor.Dark}
          largeIcon
          onClick={() => {
            track({
              verb: Verb.OPENS,
              noun: Noun.HELP_DOC_LINK,
              method: 'by clicking overlay icon',
              context: {
                url: helpLink,
              },
              source: analyticsSource,
              action: 'clicked',
              actionSubject: 'button',
              actionSubjectId: 'atlassianOnboardingHelpDocButton',
            });
            window.open(helpLink, '_blank');
          }}
        />
      )}
      <IconButton
        icon={IconName.Close}
        className={styles.icon}
        color={IconColor.Dark}
        largeIcon
        onClick={() => {
          track({
            verb: Verb.DISMISSES,
            noun: Noun.ONBOARDING_MENU,
            method: 'by clicking dismiss button',
            source: analyticsSource,
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'atlassianAccountOnboardingOverlayCloseButton',
          });
          closeDialog();
        }}
      />
    </div>
    <div className={styles.dialogContent}>
      <header className={styles.header}>
        <h2 className={styles.dialogTitle}>{title}</h2>
      </header>
      <div className={styles.dialogBody}>{children}</div>
    </div>
    <img alt="" src={WaveImageUrl} className={styles.dialogWave} />
    <img alt="" src={TacoImageUrl} className={styles.dialogTaco} />
  </div>
);
